import { ShiftDropoff } from "@domain/CRM/dropoff";
import { apiClient } from "../../../client";
import { StandardAxiosConfig, getBaseDataURL } from "../../../common";
import { DataAPI_Base } from "../base";

export class ShiftDropoffsAPI extends DataAPI_Base<ShiftDropoff> {
	constructor() {
		super("shift-dropoffs", ShiftDropoff);
	}

	/** Delete junction records outright (the portal's stop-removal semantics — MC orphans). */
	public async delete(ids: string[]): Promise<{ deleted: number }> {
		const response = await apiClient.post(`${getBaseDataURL("shift-dropoffs")}/delete`, ids, StandardAxiosConfig());
		return response.data as { deleted: number };
	}
}
